import { FC, useState, useEffect } from "react";
import moment from "moment";
import LoadingSpinner from "@app/shared/LoadingSpinner";
import { Version } from "@app/members/memberSetModels";
import MemberSetService from "@app/members/memberSetService";

interface OverallSummaryProps {
  version?: Version;
  compareVersion?: Version;
  onUpdate: (totalRecords: number) => void;
  isHidden: boolean;
}

export const MemberSetOverallSummary: FC<React.PropsWithChildren<OverallSummaryProps>> = (props: OverallSummaryProps) => {

  const memberSetService = new MemberSetService();

  const [versionMemberCount, setVersionMemberCount] = useState<number>(null);
  const [compareVersionMemberCount, setCompareVersionMemberCount] = useState<number>(null);

  useEffect(() => {

    setVersionMemberCount(null);
    if (!props.version || !props.version.memberSetVersionId)
      return;

    memberSetService.getMemberCount(props.version.memberSetId, props.version.memberSetVersionId).then((count) => {
      setVersionMemberCount(count);
      props.onUpdate(count);
    });

  }, [props.version]);

  useEffect(() => {

    setCompareVersionMemberCount(null);
    if (!props.compareVersion || !props.compareVersion.memberSetVersionId)
      return;

    memberSetService.getMemberCount(props.compareVersion.memberSetId, props.compareVersion.memberSetVersionId).then((count) => {
      setCompareVersionMemberCount(count);
    });

  }, [props.compareVersion]);

  return (
    <div className="card shadow-none border-0">
      <div className="card-header border-0 gray-500-bg pt-3 pb-3 ps-3">
        <strong>
          {!props.compareVersion ?
            "Overall Summary" :
            <div className="row">
              <div className="col-6">
                {moment.utc(props.compareVersion.dateLastUpdated).local().format("MMM DD, YYYY h:mm:ss A")} Overall Summary
              </div>
              <div className="col-6">
                {moment.utc(props.version.dateLastUpdated).local().format("MMM DD, YYYY h:mm:ss A")} Overall Summary
              </div>
            </div>
          }
        </strong>
      </div>
      { !props.isHidden &&
        <div className="row mb-1 ms-2">
          {!!props.compareVersion ?
            <div className="col-6">
              {compareVersionMemberCount != null ? (
                <>
                  <p className="mb-0">{`Member Count: ${compareVersionMemberCount.toLocaleString("en-US")}`}</p>
                </>) : <LoadingSpinner />
              }
            </div> : null
          }
          <div className="col-6">
            {versionMemberCount != null ? (
              <>
                <p className="mb-0">{`Member Count: ${versionMemberCount.toLocaleString("en-US")}`}</p>
              </>) : <LoadingSpinner />
            }
          </div>
        </div>
      }
    </div>
  );
}